import _ from 'lodash'
import {useContext, useEffect, useState} from 'react'
import {Dropdown, DropdownMenuProps} from 'semantic-ui-react'
import {AuthContext} from '@/features/auth'
import {MessageContext} from '@/features/errors'
import {DataSourcesContext} from '../../contexts'
import {DataSourceTemplates} from '../../sources'
import './style.css'

type DropdownItem = {
  value: string
  text: string
}

export function CatalogSelector(props: DropdownMenuProps & {item?: boolean}) {
  const {item, ...dropdownMenuProps} = props
  const [catalogOptions, setCatalogOptions] = useState<DropdownItem[]>([])
  const [isOpen, setIsOpen] = useState(false)

  const {logError} = useContext(MessageContext)

  const {allowed_catalogs, upload_catalogs, default_catalog} = useContext(AuthContext)

  const {isBusy, activeCatalogName, replaceSources} = useContext(DataSourcesContext)

  useEffect(() => {
    setCatalogOptions(
      _.chain([default_catalog])
        .concat(allowed_catalogs)
        .concat(upload_catalogs)
        .concat(activeCatalogName) // Include the active catalog from overrides
        .uniq()
        .compact()
        .map((c) => ({
          text: c,
          value: c,
        }))
        .value()
    )
  }, [default_catalog, allowed_catalogs, upload_catalogs, activeCatalogName])

  if (catalogOptions.length < 2) return

  return (
    <Dropdown
      item={true}
      simple={true}
      disabled={isBusy}
      open={isOpen}
      onOpen={() => setIsOpen(true)}
      onClose={() => setIsOpen(false)}
      className='catalog-selector'
      value={activeCatalogName}
      text={activeCatalogName}
      icon='dropdown'
    >
      <Dropdown.Menu {...dropdownMenuProps}>
        {catalogOptions.map(({value, text}) => {
          if (!value) return
          const isActive = value === activeCatalogName
          return (
            <Dropdown.Item
              key={value}
              content={
                <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                  {isActive && <span style={{color: '#21ba45', fontWeight: 'bold'}}>●</span>}
                  <span>{text}</span>
                </div>
              }
              onClick={() => {
                setIsOpen(false)
                try {
                  replaceSources([DataSourceTemplates.catalog({catalogName: value})])
                } catch (error: any) {
                  logError(error.message || 'unknown error', error)
                }
              }}
            />
          )
        })}
      </Dropdown.Menu>
    </Dropdown>
  )
}
